import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

class PricingSearchParams extends SearchParamsBase {
  static saveType = 'PricingSearchParams';
  initialize() {
    this.OfficeId = '';
    this.CountryId = '';
    this.FwOffice = '';
    this.StatusCode = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'PricingId', label: 'Pricing Id', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'OfficeId', label: 'FW Office', className: 'col-3', type: InputTypesEnum.OfficeOrGroupSelect },
    { fieldName: 'CountryId', label: 'Country', className: 'col-3', type: InputTypesEnum.CountrySelect },
    {
      fieldName: 'StatusCode',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.PricingStatusLookupItemSelect,
    },
  ];

  static iconName = 'fa-solid fa-search';
}

export default PricingSearchParams;
